import { createAction } from 'redux-actions';
export const ENTER_SEARCH_AND_FILTER_MODE = 'ENTER_SEARCH_AND_FILTER_MODE';
export const enterSearchAndFilterMode = createAction(ENTER_SEARCH_AND_FILTER_MODE, previouslyFocusedThreadId => ({
  previouslyFocusedThreadId
}));